export default "__VITE_ASSET__CqG57Ihq__"